import React, { useEffect, useRef } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';
import { Theme } from '@app/theme';
import { ApiFormattedException, ApiValidationFailedException } from '@app/api';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  error: {
    ...theme.fonts.caption,
    color: theme.colors.red,
    marginBottom: theme.marginBase,
  },
}));

interface Props {}

export const FormikError = (props: Props) => {
  const prevValues = useRef<any>(null);
  const prevError = useRef(null);

  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });
  const { t } = useTranslation('common');

  const formik = useFormikContext();

  useEffect(() => {
    if (prevError.current && !isEqual(prevValues.current, formik.values)) {
      prevError.current = null;
      prevValues.current = null;
      formik.setStatus(null);
      return;
    }

    if (!prevError.current && formik.status) {
      prevError.current = formik.status;
      prevValues.current = formik.values;
    }
  });

  const error = formik.status;

  if (
    !error ||
    !(error instanceof Error) ||
    error instanceof ApiValidationFailedException
  ) {
    return null;
  }

  if (error instanceof ApiFormattedException && error.getTranslatedMessage()) {
    return <div className={classes.error}>{error.getTranslatedMessage()}</div>;
  }

  return <div className={classes.error}>{t('form.errors.unknown')}</div>;
};
